export const CATCHALL_STOPWORDS = ['retard'];

export const INJURY_STOPWORDS = [
  'accident',
  'ambulance',
  'burnover',
  'casualties',
  'casualty',
  'collision',
  'collisions',
  'crash',
  'entrapment',
  'entrapped',
  'fatalities',
  'fatality',
  'injured',
  'injuries',
  'injury',
  'IWI',
  'medical',
  'rollover',
  'shelter deployed',
  'shelter deployment',
];

export const CAUSE_STOPWORDS = [
  'accidental',
  'arrest',
  'arson',
  'caught',
  'charged',
  'crime',
  'criminal',
  'human-cause',
  'human-caused',
  'investigation',
  'perpetrator',
  'suspect',
];

export const FIRST_PERSON_STOPWORDS = [
  'I',
  'me',
  'mine',
  'my',
  'myself',
  'our',
  'ours',
  'ourselves',
  'us',
  'we',
];

export const EVACUATION_STOPWORDS = [
  'evac',
  'evacs',
  'evacuation',
  'evacuations',
  'order',
  'warning',
];

export const POLITICAL_STOP_WORDS = [
  'shutdown',
  'democrat',
  'democrats',
  'democratic',
  'republican',
  'republicans',
];
